module.exports = __webpack_public_path__ + "static/img/empty_bg_attrValue.d2228819.png";